import RestService from "./service";
let restService = new RestService();

export function oneDispatchAction(type, value) {
  return (dispatch) => {
    dispatch({ type: type, payload: value });
  };
}

export function onePostAction(type, request) {
 
  return function (dispatch) {
    return restService
      .onePostService(request)
      .then((res) => {
        type && dispatch({ type: type, payload: res.data });
        return res.data;
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
}


